<template>
  <div>
    <div class="col-12 p0 py2 my1 break-word">
      <h2 class="m0 caps">
        Sélectionner un tarif
      </h2>
      <span class="h4 m0">Sélectionner une catégorie tarifaire pour <span class="bold">{{ currentParticipant.firstname }} {{ currentParticipant.lastname }}</span></span>
    </div>
    <div v-if="getOfferPrices && getOfferPrices.length">
      <Tariff
        v-for="(price, index) in getOfferPrices"
        :key="index"
        :price="price"
        :is-recurring="isRecurring"
        :selected-tariff="selectedTariff"
        :handle-click="handleClick"
        :code-valid="codeValid"
        @validateCode="validateCode"
      />
    </div>
    <h3 v-if="getOfferPrices && !getOfferPrices.length" class="m0">
      Aucun participant ne correspond à l'âge du tarif ou la date de fin de validité n'a été atteinte
    </h3>
    <div class="flex flex-wrap">
      <div class="col-12 py3 flex justify-end items-center">
        <Button class="col-4 sm-col-6" :action="handleBack" text="Precedent" color="grey-bg" />
        <Button v-if="!loading" class="col-4 sm-col-6 ml2" :disabled="selectedTariff === -1 || getSelectedTariff?.isGymlibTariff && !codeValid" :action="confirmTariff" text="Suivant" />
        <Button v-else class="col-4 sm-col-6 ml2" :disabled="true" icon="icon icon-loader" />
      </div>
    </div>
  </div>
</template>

<script>
import Button from '../../components/elements/Button';
import Tariff from '@/components/tariffs/Tariff';

import { changeToPage, handleOptionFlow, handleTariff, computePromo } from '@/utils/logics';
import { generateImageUrl, computedOfferPrices } from '@/utils/utils';

export default {
  components: { Button, Tariff },
  data () {
    return {
      offer: this.$store.state.offerInfo,
      selectedTariff: -1,
      currentParticipant: this.$store.state.currentParticipant,
      loading: false,
      codeValid: false
    };
  },
  computed: {
    selectedPeriod () {
      return this.$store.state.selectedPeriod;
    },
    siteInfo () {
      return this.$store.state.siteInfo;
    },
    getOfferPrices () {
      const offerPrices = computedOfferPrices(this.currentParticipant, this.offer);

      return offerPrices.filter(offer => {
        if (this.selectedPeriod) {
          return offer.period.uuid === this.selectedPeriod.uuid;
        }

        return offer;
      });
    },
    getSelectedTariffIndex () {
      const tariffs = this.getOfferPrices;
      const { currentParticipant } = this.$store.state;

      if (this.siteInfo.is_internal_session) {
        if (!currentParticipant.tariff) {
          return -1;
        }
        const tariff = tariffs.find(t => t.period.uuid === currentParticipant.tariff.period.uuid && t.priceCategory.uuid === currentParticipant.tariff.priceCategory.uuid);
        return tariff ? tariff.index : -1;
      }

      return currentParticipant.tariff ? tariffs.findIndex(tariff => tariff.tariffCode === currentParticipant.tariff.tariffCode) : -1;
    },
    isRecurring () {
      return this.offer.detail.recurring;
    },
    product () {
      return this.$store.state.product;
    },
    getSelectedTariff () {
      return this.getOfferPrices.find(p => p.index === this.selectedTariff);
    }
  },
  created () {
    const { cartItem } = this.$store.state;
    if (!cartItem) {
      let imageUrl = null;
      if (this.product.header_images && this.product.header_images.length) {
        imageUrl = this.generateImageUrl(this.product.header_images[0], 't_UCPA_Vertical');
      } else if (this.product.headerImagesSEO && this.product.headerImagesSEO.length && this.product.headerImagesSEO[0].url) {
        imageUrl = this.generateImageUrl(this.product.headerImagesSEO[0].url, 't_UCPA_Vertical');
      }
      this.$store.commit('setCartItem', {
        workspace: this.product.workspace,
        participants: [],
        details: {
          offerUuid: this.offer.uuid,
          stock: this.offer.stock,
          contremarque: this.offer.contremarque,
          sans_support: this.offer.sans_support,
          tda_info: this.offer.tda_info,
          first_purchase: this.offer.detail.first_purchase,
          horanet_product_name: this.siteInfo && this.siteInfo.is_internal_session ? this.offer.name : this.offer.horanet_product.name,
          horanet_product_code: this.siteInfo && this.siteInfo.is_internal_session ? this.offer.uuid : this.offer.horanet_product.horanet_product_code,
          horanet_product_reference: this.siteInfo && this.siteInfo.is_internal_session ? this.offer.uuid : this.offer.horanet_product.horanet_product_reference,
          inscription: this.offer.detail.inscription,
          pass: this.offer.detail.pass,
          product_image: imageUrl || null,
          recurring: this.offer.detail.recurring,
          stage: this.offer.detail.stage,
          stage1D: this.offer.detail.stage1D,
          license: this.offer.detail.license,
          reloadable: this.offer.detail.reloadable,
          isClubCard: this.offer.detail.isClubCard,
          reservation: this.offer.detail.reservation,
          unit_sales: this.offer.detail.unit_sales,
          insurance: this.offer.detail.insurance,
          product_name: this.product.name,
          product_uuid: this.product.uuid,
          product_type: this.offer.name,
          cancelation: this.offer.cancelation,
          offer_type: this.offer.offer_type,
          offerProductType: this.offer.productType,
          activities: (this.offer.detail.activities || []).map(act => act.uuid)
        }
      });
    }
    this.selectedTariff = this.getSelectedTariffIndex;
    const prices = this.getOfferPrices;

    if (prices.length === 1) {
      this.selectedTariff = prices[0].index;
      if (!prices[0]?.isGymlibTariff) {
        this.confirmTariff();
      }
    }
  },
  methods: {
    changeToPage,
    handleOptionFlow,
    handleTariff,
    generateImageUrl,
    computePromo,
    validateCode (event) {
      this.codeValid = event;
    },
    handleBack () {
      if (this.selectedPeriod) {
        this.changeToPage('Periods');
        return;
      }
      this.changeToPage('AddParticipant');
    },
    handleClick (index) {
      this.currentParticipant.gymlibCode = null;
      this.codeValid = false;
      this.selectedTariff = index;
    },
    async confirmTariff () {
      this.loading = true;
      await this.handleTariff(this.selectedTariff);
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
  .offer-card {
    .card-top {
      padding:  2rem 4rem;

    }
    .card-bottom {
      padding: 1rem 4rem;
    }
  }
  @media (max-width: 40rem) {
    .offer-card {
      .card-top {
        padding:  1rem 2rem;

      }
      .card-bottom {
        padding: 1rem 2rem;
      }
  }
}
</style>
